import { render } from "./AnnouncementPendoIcon.vue?vue&type=template&id=b7b4c0c8&scoped=true"
import script from "./AnnouncementPendoIcon.vue?vue&type=script&lang=js"
export * from "./AnnouncementPendoIcon.vue?vue&type=script&lang=js"

import "./AnnouncementPendoIcon.vue?vue&type=style&index=0&id=b7b4c0c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b4c0c8"]])

export default __exports__